import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const LastPage = () => {
   const { state } = useLocation();
   const dispatch = useDispatch();
   const navigate = useNavigate();

   useEffect(() => {
      if (!state?.fromApp) {
         return navigate("/auth/login");
      }
   }, [state, navigate]);

   return (
      <>
         <div className="text-center lastpage-title">
            <h2 className="font-size-h2 mt-20">
               <FormattedMessage id="AUTH.REGISTER.TITLE.STEP4" />
            </h2>
            <div className="lastpage-img">
               <img src={toAbsoluteUrl("/media/bg/Frame.png")} alt="frame" />
            </div>
         </div>

         <div className="d-flex justify-content-center lastpage-content-text  mt-xl-20 mt-5 mt-lg-2">
            <h2>
               <FormattedMessage id="AUTH.REGISTER.TITLE.STEP5" />
            </h2>
         </div>
         <div className="d-flex justify-content-center lastpage-button">
            <Link to="/auth/login">
               <button type="button" className="btn btn-last font-weight-bold px-8 py-4 my-3 mx-4 ">
                  Sign in now
               </button>
            </Link>
         </div>
         <div className="lastpage-line"></div>
      </>
   );
};

export default LastPage;
